export { default } from './ModalNewCustomer'
